module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-05.a7fcf817.png";